export default axios => ({

    getAppointmentsData(payLoad) {
        return axios.get(`/dashboard`, payLoad);
    },
    getDeviceInfo(department) {
        return axios.get(`/${department}/cardio`)
    },
    getValidationData(payLoad) {
        return axios.get(`/dashboard-validation`, payLoad);
    }


})
